<template>
    <div
        class="d-flex flex-column align-items-center justify-content-center"
        style="height: 100vh;"
    >
        <div class="text-center mb-3" style="width: 300px; max-width: 300px;">
            <img :src="loginLogo" class="logo" :alt="$t('app-credits')"/>
        </div>
        <template v-if="tokenValid === null">
            <b-spinner variant="primary" :label="$t('loading')"></b-spinner>
        </template>
        <template v-else-if="tokenValid === false">
            <div
                class="card border-light"
                style="width: 18rem;"
            >
                <div class="card-body text-center">
                    <b-icon icon="exclamation-circle-fill" variant="danger" font-scale="7.5" class="mb-2"></b-icon>
                    <h5 class="card-title">{{ $t("invalid-link") }}</h5>
                    <p class="card-text">
                        {{ tokenErrorMessage }}
                    </p>
                    <button
                        class="btn btn-primary mt-2"
                        @click="goToLogin()"
                    >
                        {{$t('login')}}
                    </button>
                </div>
            </div>
        </template>
        <template v-else-if="passwordUpdated">
            <div
                class="card border-light"
                style="width: 18rem;"
            >
                <div class="card-body text-center">
                    <b-icon icon="check-circle-fill" variant="success" font-scale="7.5" class="mb-2"></b-icon>
                    <h5 class="card-title">{{ $t("done") }}</h5>
                    <p class="card-text">
                        {{ $t('password-updated') }}
                    </p>
                    <button
                        class="btn btn-primary mt-2"
                        @click="goToLogin()"
                    >
                        {{$t('login')}}
                    </button>
                </div>
            </div>
        </template>
        <template v-else>
            <div
                class="card border-light"
                style="width: 18rem;"
            >
                <div class="card-body text-center">
                    <h5 class="card-title">{{ $t("change-password") }}</h5>
                    <b-alert
                        v-if=error
                        variant="danger"
                        show
                    >
                        {{error}}
                    </b-alert>
                    <PasswordInput
                        id="password1"
                        v-model="newPassword"
                        :label="$t('new-password')"
                        sr-only
                        :placeholder="$t('new-password')"
                        autocomplete="new-password"
                        :error-message="passwordTooShort ? $t('password-min-length') : ''"
                        show-strength
                        class="mb-2 text-left"
                    />
                    <PasswordInput
                        id="password2"
                        v-model="confirmNewPassword"
                        :label="$t('confirm-new-password')"
                        sr-only
                        :placeholder="$t('confirm-new-password')"
                        autocomplete="new-password"
                        :error-message="passwordMismatch ? $t('password-and-confirm-not-equal') : ''"
                        class="mb-0 text-left"
                    />
                    <button
                        class="btn btn-primary btn-login mt-2"
                        @click="setPassword()"
                        :disabled="newPassword !== confirmNewPassword || newPassword.length < 6"
                    >
                        {{$t('update')}}
                    </button>
                </div>
            </div>
        </template>


    </div>
</template>
<script>
export default {
	components: {
     
	},
    data() {
        return {
            tokenValid: null,
            tokenErrorMessage: null,
            passwordUpdated: false,
            newPassword: '',
            confirmNewPassword: '',
            appurl:null,
            error:null
        }
    },
    mounted(){
        this.validateToken();
    },
    computed: {
        isMolarOnly() {
            return this.$config.hasModule('molaronly');
        },
        loginLogo() {
            if (this.isMolarOnly) {
                return require('../../assets/branding/molar-logo.png');
            }
            return require('../../assets/branding/logo.png');
        },
        passwordTooShort() {
            return this.newPassword.length > 0 && this.newPassword.length < 6;
        },
        passwordMismatch() {
            return this.newPassword.length > 0 && this.confirmNewPassword.length > 0 && this.newPassword !== this.confirmNewPassword;
        }
    },
    methods: {
        validateToken() {
            this.$cfetch(`${this.$settings.APIBaseURL}/users/passwordreset/validatetoken`, {
                method: "get",
                data: {
                    t: this.$route.params.token
                },
            }).then((res) => {
                if (res.status !== "SUCCESS") {
                    this.tokenErrorMessage = this.getTokenErrorMessage(res.errorType, res.errorMessage);
                    this.tokenValid = false;
                    return;
                }

                this.tokenValid = true;
            })
            .catch((error) => {
                this.tokenErrorMessage = this.getTokenErrorMessage(null, null);
                this.tokenValid = false;
                this.$log.error.call(this, error);
            });
        },
        getTokenErrorMessage(errorType, errorMessage) {
            switch (errorType) {
                case 'CODE_EXPIRED':
                    return this.$t('link-expired');
                case 'USER_SUSPENDED_OR_DELETED':
                    return this.$t('account-inactive');
                case 'TOKEN_MISMATCH':
                    return this.$t('link-invalid');
                default:
                    return errorMessage || this.$t('link-invalid');
            }
        },
        setPassword() {
			this.$cfetch(`${this.$settings.APIBaseURL}/users/passwordreset/default`, {
				method: "post",
				data: {
                    pass1: this.newPassword,
                    pass2: this.confirmNewPassword,
                    t: this.$route.params.token
                },
			}).then((res) => {
                if (res.status !== "SUCCESS") {
                    this.error = res.errorMessage;
                    throw new Error('Something went wrong');
                }
                    
                this.passwordUpdated = true;
                this.appurl = res.appurl

            })
            .catch((error) => {
                this.$log.error.call(this, error);
            });
		},
        goToLogin(){
            window.location.href = this.appurl || '/'
        }
    }
} 
</script>